export default __webpack_public_path__ + "static/media/banner.618abc42.svg";